module.exports = {
    STOCK_CHECKER_DISPLAY_MODE: {
        STOCK_CHECKER: 'StockChecker',
        STORE_SWITCHER: 'StoreSwitcher',
    },
    MHSF: 'MHSF',
};



// WEBPACK FOOTER //
// ./src/productdetail/product-detail.constants.js